import { ProjectFormTabProvider } from "components/pages/ProfessionalSpace/ProjectFormContext";
import { ProjectTeamProvider } from "./contexts/ProjectTeam";
import ProfessionalSpaceLayout from "./ProfessionalSpaceLayout";
import { EProjectTab, useProjectFormTab } from "./ProjectFormContext";
import Actions from "./tabs/Actions";
import Casting from "./tabs/Casting";
import Forum from "./tabs/Forum";
import Media from "./tabs/Media";
import Team from "./tabs/Team";
import Votes from "./tabs/Votes";
import { ProjectTitleProvider } from "./contexts/ProjectTitle";
import { ProjectProvider } from "../FeaturedProjects/contexts/Project";
import { BannerProvider } from "./contexts/Banner";
import InformationContent from "./tabs/Informations/Content";
import ProjectLeader from "./tabs/Informations/ProjectLeader";
import SocialMedia from "./tabs/Informations/SocialMedia";
import Documents from "./tabs/Informations/Documents";

function ProjectConfigContent() {
	const { currentTab } = useProjectFormTab();
	return (
		<ProfessionalSpaceLayout>
			{currentTab === EProjectTab.INFORMATION_CONTENT && <InformationContent />}
			{currentTab === EProjectTab.INFORMATION_PROJECT_LEADER && <ProjectLeader />}
			{currentTab === EProjectTab.INFORMATION_DOCUMENTS && <Documents />}
			{currentTab === EProjectTab.INFORMATION_CONTACT_AND_SOCIALS && <SocialMedia />}
			{currentTab === EProjectTab.VOTES && <Votes />}
			{currentTab === EProjectTab.ACTIONS && <Actions />}
			{currentTab === EProjectTab.FORUM && <Forum />}
			{currentTab === EProjectTab.CASTING && <Casting />}
			{currentTab === EProjectTab.MEDIA && <Media />}
			{currentTab === EProjectTab.TEAM && <Team />}
		</ProfessionalSpaceLayout>
	);
}

export default function EditProjectConfig() {
	return (
		<ProjectProvider>
			<ProjectTitleProvider>
				<ProjectTeamProvider>
					<ProjectFormTabProvider>
						<BannerProvider>
							<ProjectConfigContent />
						</BannerProvider>
					</ProjectFormTabProvider>
				</ProjectTeamProvider>
			</ProjectTitleProvider>
		</ProjectProvider>
	);
}
